import wireframeSearchBar from '../assets/icons/wireframeSearchBar.svg';
import WireframeInputField from './WireframeInputField';
import { type IconData } from '../types';

class WireframeSearchBar extends WireframeInputField {
  initItems(): void {
    this.addDropdownItems();
    if (!this.label) {
      this.addLabel({ value: 'Label', position: 'noLabel' });
    }
    if (!this.placeholder) {
      this.addPlaceholder({
        value: 'Search...',
        state: 'placeholder',
        iconLeft: { prefix: 'fas', iconName: 'magnifying-glass' } as IconData,
      });
    }
  }

  static iconSvg() {
    return wireframeSearchBar;
  }

  static externalName(): string {
    return 'Search bar';
  }
}

export default WireframeSearchBar;
